<template>
  <accordion-simple-item title="Formular" :flex="true" v-if="userData?.isAdmin">
    <div class="flex flex-grow flex-col overflow-hidden h-full">
      <button class="p-1 bg-white mb-4 mt-2  w-full hover:bg-trader-blue hover:text-white"
              @click="navigateTo(`/administration/${accordionIndex}/createFormular`, )" data-ui="create-new-formular">Neues Formular erstellen
      </button>
      <div class=" overflow-y-auto " data-ui="formular-list">
        <div v-for="formularName in formularNames " :key="formularName.idForm">
          <div class="w-full p-1  flex my-2 "
               :class="{ 'bg-trader-blue text-white': formularId == formularName.idForm, 'bg-trader-dark-gray': formularId != formularName.idForm }"
               @click="navigateTo(`/administration/${accordionIndex}/formular`, { formId: formularName.idForm })">
                  <span class="w-full cursor-pointer" :data-ui="'formular-'+ formularName.name">
                  {{ formularName.name }}
                 </span>
          </div>
        </div>
      </div>
    </div>
  </accordion-simple-item>
</template>

<script>
import TRInput from "@/components/Base/TRInput.vue";
import {mapState} from "vuex";
import AccordionItem from "@/components/Accordion/AccordionItem.vue";
import AccordionSimpleItem from "@/components/Accordion/AccordionSimpleItem.vue";
import router from "@/router";
import SignalBus from "@/application/SignalBus";
import apolloClient from "@/apolloClient";
import {gql} from "@apollo/client/core";

export default {
  name: "SPurchaser",
  data() {
    return {
      magazinesSearch: '',
      magazineTypes: [],
      formularNames: null,
      formularId: 0,
    }
  },
  components: {
    AccordionSimpleItem,
    AccordionItem,
    TRInput,
  },
  props: {
    accordionIndex: {
      type: Number,
      default: () => {
      }
    },
  },
  computed: {
    ...mapState('user', ['userData']),
  },
  methods: {
    navigateTo(route, params = {}) {
      let path = route;
      // Aufbau des Pfades basierend auf übergebenen Parametern
      if (Object.keys(params).length) {
        const paramParts = Object.keys(params).map(key => params[key]);
        path += '/' + paramParts.join('/');
      }
      router.push(path);
      if (route.includes('page')) {
        SignalBus.emit("sidebar-reload-project_date");
      }
      if (route.includes('template')) {
        this.pageTemplateId = params.templateId;
      }
    },
    async getFormularNames() {
      try {
        const response = await apolloClient.query({
          query: gql`
            query getFormularNames {
              getFormularNames {
                idForm
                name
                magazineType
              }
            }
          `
        });

        this.formularNames = response.data.getFormularNames;

      } catch (error) {
        console.error("Fehler beim Abrufen der formularNames:", error);
      }
    },
  },
  mounted() {
    this.getFormularNames();

    SignalBus.connect(this,"sidebar-update-formular-name", this.getFormularNames);
  },
  beforeUnmount() {
     SignalBus.disconnectAllFromParent(this);
  },
  created() {
    this.formularId =  this.$route.params.formId
  },
  watch: {
    '$route.params.formId': function (newId, oldId) {
      this.formularId = newId;
      this.getFormularNames();
    },
  },
}
</script>